class CartDrawer extends Cart {
  constructor() {
    super();
  }

  get selectors() {
    return {
      ...super.selectors,
      section: "cart-drawer",
      drawer: {
        button: {
          open: "[data-cart-drawer-open]",
          close: "[data-cart-drawer-close]"
        },
        scrollableContent: "[data-cart-drawer-scrollable]"
      }
    }
  }

  get modifiers() {
    return {
      ...super.modifiers,
      drawer: {
        open: "cart-drawer--open"
      }
    }
  }

  connectedCallback() {
    super.connectedCallback();

    document.documentElement.customDelegate(
      "click",
      this.selectors.drawer.button.open,
      this.openDrawer.bind(this)
    );

    document.documentElement.customDelegate(
      "click",
      this.selectors.drawer.button.close,
      this.closeDrawer.bind(this)
    );

    document.addEventListener("cart-drawer:open", this.openDrawer.bind(this));
    document.addEventListener("cart-drawer:close", this.closeDrawer.bind(this));

    window.addEventListener("resize", this.setDrawerHeight.debounce(50));
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    document.removeEventListener("cart-drawer:open", this.openDrawer.bind(this));
    document.removeEventListener("cart-drawer:close", this.closeDrawer.bind(this));

    window.removeEventListener("resize", this.setDrawerHeight.debounce(50));
  }

  openDrawer(event) {
    event.preventDefault();

    const scrollableContent = this.querySelector(this.selectors.drawer.scrollableContent);

    bodyScrollLock.disableBodyScroll(scrollableContent);

    this.classList.add(this.modifiers.drawer.open);

    this.focusDrawer();
  }

  closeDrawer(event) {
    event.preventDefault();

    const scrollableContent = this.querySelector(this.selectors.drawer.scrollableContent);

    this.classList.remove(this.modifiers.drawer.open);

    bodyScrollLock.enableBodyScroll(scrollableContent);

    this.returnFocusToPreviousElement();
  }

  setDrawerHeight() {
    const cardDrawerHeight = window.innerHeight;

    document.documentElement.style.setProperty(
      '--cart-drawer-height',
      `${cardDrawerHeight}px`
    );
  }

  focusDrawer() {
    this.previouslyFocusedElement = document.activeElement;

    this.focus({
      preventScroll: true
    });
  }

  returnFocusToPreviousElement() {
    if (this.previouslyFocusedElement) {
      this.previouslyFocusedElement.focus();
    }
  }
}

if (!customElements.get("cart-drawer")) {
  customElements.define("cart-drawer", CartDrawer);
}
